<template>
    <div class="cursor-pointer rotatable hover:text-gray-500"
         :class="{ rotated: showChildren }"
         @click.prevent="showChildren = !showChildren">
      <IconChevron></IconChevron>
    </div>
</template>

<script>
import IconChevron from '@/components/icons/IconChevron'

export default {
  name: 'RowChildToggle',
  props: {
    value: Boolean
  },
  components: {
    IconChevron
  },
  computed: {
    showChildren: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  }
};
</script>

<style scoped>
.rotatable {
  transform: rotate(-90deg);
  transition: all ease-out 0.05s;
}
.rotatable:focus {
  outline: 0;
}
.rotatable.rotated {
  transform: rotate(0deg);
}
.sortable-ghost {
  border: 2px dashed #2d3748;
}
</style>